// extracted by mini-css-extract-plugin
module.exports = {"chip__text":"ChipLink_chip__text__lPIBL"};